// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"194":"component---src-templates-post-tsx","223":"commons","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"194":"78fece7f634c00012c89","223":"5fa492a870a78da8dbda","245":"71deb30025bc59f13a4b"}[chunkId] + ".js";
};